import React from "react"
import { Row, Col } from "react-bootstrap"

import { formatDate } from "../../utils/format-date-time"

const TimelineInfo = ({ data }) => {
  return (
    <div className="timeline-info">
      <Row>
        <Col lg="5">
          <h5>{data.college ? data.college : ""}</h5>
          <p>
            {formatDate(data.from_year)} -{" "}
            {data?.to_year === "Current" ? "Current" : formatDate(data.to_year)}
          </p>
        </Col>
        <Col lg="5">
          <p className="designation">
            {data.degreetype
              ? data.degreetype_name
              : "No degree name available"}
            {" - "}
            {data.degree ? data.degree : "No degree name available"}
          </p>
        </Col>
      </Row>
    </div>
  )
}

export default TimelineInfo
